<script setup lang="ts">
import type { PropType } from 'vue';

import type { SaleAssetBusEntity, SaleAssetBusListingItem } from '~/apiClient';

const { mainAsset } = defineProps({
    mainAsset: { type: Object as PropType<SaleAssetBusEntity | SaleAssetBusListingItem>, required: true },
});

const firstImage = computed(() => mainAsset.images.cover.at(0));
const secondImage = computed(() => mainAsset.images.cover.at(1));
const onceHover = ref(false);
const { saleImageAlt } = useA11y();
</script>

<template>
    <div class="grid grid-cols-1">
        <NuxtImg
            v-if="firstImage"
            class="col-start-1 row-start-1"
            :src="firstImage"
            sizes="760 md:480"
            densities="x1"
            draggable="false"
            loading="lazy"
            :alt="saleImageAlt(mainAsset, firstImage)"
            @mouseover="onceHover = true"
        />
        <ClientOnly>
            <NuxtImg
                v-if="secondImage && onceHover"
                :src="secondImage"
                class="col-start-1 row-start-1 max-w-full opacity-0 transition-opacity hover:opacity-100"
                sizes="760 md:480"
                densities="x1"
                draggable="false"
                loading="lazy"
                :alt="saleImageAlt(mainAsset, secondImage)"
            />
        </ClientOnly>
    </div>
</template>
